var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup57(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 61,
    viewBox: "0 0 50 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3873 8.7002H20.3983M29.6002 8.7002H36.6112M25.2183 22.9971L21.9319 30.2627H28.9429L25.2183 38.2314M36.6112 51.3564H29.6002M13.3152 51.3564H20.3983M24.9992 16.2002V13.3877M24.9992 43.3877V46.2002",
    stroke: "#006D77",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2197 16.9658C31.744 16.966 37.1465 22.6447 37.1465 29.7939C37.1465 36.9432 31.744 42.6219 25.2197 42.6221C18.6953 42.6221 13.293 36.9433 13.293 29.7939C13.293 22.6446 18.6953 16.9658 25.2197 16.9658Z",
    stroke: "#006D77",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.02295,
    y: 43.2158,
    width: 11.5838,
    height: 15.8125,
    rx: 5.79191,
    stroke: "#006D77",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.02295,
    y: 1.02832,
    width: 11.5838,
    height: 15.8125,
    rx: 5.79191,
    stroke: "#006D77",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.3936,
    y: 1.02832,
    width: 11.5838,
    height: 15.8125,
    rx: 5.79191,
    stroke: "#006D77",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37.3936,
    y: 43.2158,
    width: 11.5838,
    height: 15.8125,
    rx: 5.79191,
    stroke: "#006D77",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1814,
    y: 46.9658,
    width: 7.64012,
    height: 8.3125,
    rx: 3.82006,
    stroke: "#006D77",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1814,
    y: 4.30957,
    width: 7.64012,
    height: 8.3125,
    rx: 3.82006,
    stroke: "#006D77",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup57);
export default __webpack_public_path__ + "static/media/Group 57.6630ec39d28d1b4a413c5738d7c32f3c.svg";
export { ForwardRef as ReactComponent };